import { useEffect } from "react";

/**
 * Хук для обработки клавиатурной навигации
 * @param {Object} options - Настройки навигации
 * @param {Function} options.onGoLeft - Callback для движения влево/назад
 * @param {Function} options.onGoRight - Callback для движения вправо/вперед
 * @param {Array} options.leftKeys - Массив клавиш для движения влево (по умолчанию: ArrowLeft, PageUp)
 * @param {Array} options.rightKeys - Массив клавиш для движения вправо (по умолчанию: ArrowRight, PageDown, Space)
 * @param {boolean} options.preventDefaultOnMatch - Предотвращать ли поведение по умолчанию для обработанных клавиш
 */
export default function useKeyboardNavigation({
  onGoLeft,
  onGoRight,
  leftKeys = ["ArrowLeft", "PageUp"],
  rightKeys = ["ArrowRight", "PageDown", " "],
  preventDefaultOnMatch = true,
} = {}) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Не обрабатываем клавиши, если фокус в элементе ввода
      const activeElement = document.activeElement;
      const isInputFocused =
        activeElement &&
        (activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA" ||
          activeElement.isContentEditable);

      if (isInputFocused) return;

      // Проверяем клавиши для движения влево
      if (leftKeys.includes(event.key) && onGoLeft) {
        if (preventDefaultOnMatch) {
          event.preventDefault();
        }
        onGoLeft();
        return;
      }

      // Проверяем клавиши для движения вправо
      if (rightKeys.includes(event.key) && onGoRight) {
        if (preventDefaultOnMatch) {
          event.preventDefault();
        }
        onGoRight();
        return;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onGoLeft, onGoRight, leftKeys, rightKeys, preventDefaultOnMatch]);
}
